import { useQuery } from '@tanstack/react-query';

import { useApiClient } from '@/api/clients/useApiClient.util.ts';
import { type AnnouncementsFeedDto } from '@/api/generated';
import { QueryKeyEnum } from '@/api/model/QueryKey.enum.ts';

const REFRESH_MS = 60 * 1000;

type Return = {
  feed: AnnouncementsFeedDto | undefined;
  isPending: boolean;
};

export const useTeamAnnouncements = (limit: number): Return => {
  const { teamAnnouncementsApi } = useApiClient();

  const { data, isPending } = useQuery<AnnouncementsFeedDto>({
    queryFn: async () => {
      const { data } = await teamAnnouncementsApi.readAnnouncements(limit);
      return data;
    },
    queryKey: [QueryKeyEnum.TEAM_ANNOUNCEMENTS.FEED, limit],
    refetchInterval: REFRESH_MS,
  });

  return {
    feed: data,
    isPending,
  };
};
